<template>
  <div class="openPage">
    <div class="pageBg" :style="{width:clientWidth+'px',height:clientHeight+'px'}">
      <div class="ui-linebar" :style="{width:clientWidth+'px'}">
        <div class="ink"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clientWidth: window.innerWidth,
      clientHeight: window.innerHeight,
    };
  },
};
</script>
<style scoped lang="scss">
.pageBg {
  background-color: #fd5a01;
  .ui-linebar {
    // width: 1000px;
    background-color: #fd5a01;
    opacity: 1;
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 2;
    height:2px;
    margin-left: -0.5px;
    .ink {
      -webkit-animation: Open-ink 3s ease -0.5s infinite;
      animation: Open-ink 3s ease -0.5s infinite;
      background-color: #ffffff;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      -webkit-transform: scaleX(0);
      -ms-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0 0;
      -ms-transform-origin: 0 0;
      transform-origin: 0 0;
    }
  }
}
@keyframes Open-ink {
  0% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }
  25% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }
  100% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}
</style>